import styled from 'styled-components';

export const Container = styled.div`
  .select-style {
    padding: 0 0.5rem;
    width: 100%;
    border-radius: unset;
    border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
  }

  .MuiOutlinedInput-input {
    color: ${({ theme }) => theme.colors.text};
    font-size: 1.4rem;
    font-family: 'Futura PT';
  }
  .MuiOutlinedInput-notchedOutline {
    border: none;
    border-bottom: 1px ${({ theme }) => theme.colors.primary} solid;
    border-radius: unset;
  }
`;
